import { FC, useCallback, useMemo, useRef } from "react";
import { twMerge } from "tailwind-merge";

import { ArrowDownIcon } from "../icons";

import { Button } from "./Button";
import { type ButtonKind } from "./ButtonKinds";

import { CSVData, csvObjUrlFromData, formatCSVFilename } from "utils/file";
import { Link } from "utils/routing";

type DownloadCSVButtonProps = {
  title: string;
  csvData: CSVData;
  text?: string;
  kind?: ButtonKind;
  className?: string;
};

export const DownloadCSVButton: FC<DownloadCSVButtonProps> = ({
  title,
  csvData,
  text,
  kind = "transparentSquareLegacy",
  className,
}) => {
  const buttonRef = useRef<HTMLAnchorElement>(null);
  const downloadLink = useMemo(() => csvObjUrlFromData(csvData), [csvData]);
  const handleClick = useCallback(() => {
    if (buttonRef.current) {
      buttonRef.current.download = formatCSVFilename(title);
    }
  }, [buttonRef, title]);

  return (
    <Button
      as={Link}
      className={twMerge("h6 gap-2", className)}
      kind={kind}
      ref={buttonRef}
      size="s"
      target="_blank"
      title="Download CSV"
      to={downloadLink}
      onClick={handleClick}
    >
      {text && <div>{text}</div>}
      <ArrowDownIcon />
    </Button>
  );
};
